import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Page } from '../../components/Layout'
import { Login } from '../../components/Login'
import { useAuth } from '../../hooks/useAuth'
import { supabase } from '../../lib/supabase'
import { dataBR, statusLabel } from '../../lib/format'

interface CasoFila {
  id: string
  status: string
  empreendimento: string | null
  construtora: string | null
  created_at: string
  clientes: { nome: string } | null
}

// Estados que demandam ação da equipe de produção.
const EM_PRODUCAO = ['docs_pendentes', 'em_producao', 'aguardando_revisao', 'aguardando_liminar', 'protocolado']

export default function Producao() {
  const { user, loading } = useAuth()
  const [staff, setStaff] = useState<boolean | null>(null)
  const [casos, setCasos] = useState<CasoFila[]>([])

  useEffect(() => {
    if (loading || !user) return
    ;(async () => {
      const { data: perfil } = await supabase.from('perfis').select('papel').eq('user_id', user.id).maybeSingle()
      const isStaff = perfil?.papel === 'staff'
      setStaff(isStaff)
      if (isStaff) {
        const { data } = await supabase
          .from('casos')
          .select('id, status, empreendimento, construtora, created_at, clientes(nome)')
          .in('status', EM_PRODUCAO)
          .order('created_at', { ascending: true })
        setCasos((data as unknown as CasoFila[]) ?? [])
      }
    })()
  }, [loading, user])

  if (loading) return <Page><p className="text-pfa-slate">Carregando…</p></Page>
  if (!user) return <Page><Login staff /></Page>
  if (staff === false) return <Page><div className="card"><p className="text-pfa-slate">Área restrita à equipe.</p></div></Page>

  const revisao = casos.filter((c) => c.status === 'aguardando_revisao')

  return (
    <Page>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-pfa-navy">Produção</h1>
        <div className="flex gap-3">
          <Link to="/interno" className="btn-ghost">Fila de casos</Link>
          <Link to="/interno/metricas" className="btn-ghost">Métricas</Link>
        </div>
      </div>

      {revisao.length > 0 && (
        <div className="mt-4 rounded-lg border border-pfa-coral/30 bg-pfa-coral/5 px-4 py-3 text-sm text-pfa-navy">
          <strong>{revisao.length}</strong> peça(s) aguardando revisão da equipe.
        </div>
      )}

      <div className="mt-6 space-y-2">
        {casos.map((c) => (
          <Link
            key={c.id}
            to={`/interno/caso/${c.id}`}
            className="card flex items-center justify-between hover:border-pfa-navy/30"
          >
            <div>
              <p className="font-medium text-pfa-navy">{c.empreendimento ?? 'Caso'} — {c.clientes?.nome ?? '—'}</p>
              <p className="text-xs text-pfa-slate/70">{c.construtora ?? '—'} · entrou em {dataBR(c.created_at)}</p>
            </div>
            <span className="rounded-full bg-pfa-navy/10 px-3 py-1 text-xs text-pfa-slate">{statusLabel(c.status)}</span>
          </Link>
        ))}
        {casos.length === 0 && <p className="text-pfa-slate">Nenhum caso em produção no momento.</p>}
      </div>
    </Page>
  )
}
